import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop errors (triggered by TradingView charts)
const _onerror = window.onerror;
window.onerror = (msg, ...rest) => {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
  return _onerror ? _onerror(msg, ...rest) : false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline app shell caching (production only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
